import { skillData } from "../../data";

const Skills = ({ theme }) => {
  const newTheme = `${theme} d-flex flex-column min-vh-100 justify-content-center`;
  const spanStyle = {
    fontWeight:'400px',
    fontStyle:'normal',
    textDecoration:'none'
    // color:'#000'
  }

  return (
    <section id="skills" className={newTheme}>
      <div className="container text-center">
        <h2>Skills</h2>
        <hr />
        {/* <div className="row row-cols-3">
          {skillData.map((skills) => {
            return (
              <figure className="col" key={skills.id}>
                {skills.skill}
                <figcaption>{skills.name}</figcaption>
              </figure>
            );
          })}
        </div> */}
        <div className="d-flex justify-content-center">

            <table className="tg">
            <tbody>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Deliverables</span></td>
                <td className="tg-0lax"><span style={spanStyle}>SPA, PWA, Hybrid Web-Native iOS, tvOS &amp; Android Apps, UX/UI, </span><br></br>
                  <span style={spanStyle}>Database Architecture, API Development, Scalable Hosting.</span>
                </td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Languages</span></td>
                <td className="tg-0lax"><span style={spanStyle}>HTML, CSS, Javascript/Typescript, PHP, Bash, C#.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Frontend Frameworks</span></td>
                <td className="tg-0lax"><span style={spanStyle}>ReactJS, React Native, VueJS (2 & 3), Ionic Capacitor, Quasar.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Backend</span></td>
                <td className="tg-0lax"><span style={spanStyle}>NodeJS, Laravel, Ruby on Rails.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Database</span></td>
                <td className="tg-0lax"><span style={spanStyle}>SQL, SQLite, MongoDB, PostgreSQL, MongoDB, Redis.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Testing</span></td>
                <td className="tg-0lax"><span style={spanStyle}>PHPUnit, Dusk, Cypress.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Cloud</span></td>
                <td className="tg-0lax"><span style={spanStyle}>AWS, Microsoft AppCenter, Google Cloud, Heroku, Docker.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Project Management</span></td>
                <td className="tg-0lax"><span style={spanStyle}>Git, Github, Gitlab, Agile Methodology, Kanban, Scrum, Working remotely.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Other Technologies</span></td>
                <td className="tg-0lax"><span style={spanStyle}>Vuex/Pinia/Redux, MapBox/Leaflet, WebRTC, Websockets/SocketIO/Pusher.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Hardware</span></td>
                <td className="tg-0lax"><span style={spanStyle}>Arduino, Raspberry Pi.</span></td>
              </tr>
              <tr>
                <td className="tg-baqh"><span style={spanStyle}>Software</span></td>
                <td className="tg-0lax"><span style={spanStyle}>VScode, Android Studio, Xcode, Unity, Adobe Photoshop &amp; Premiere Pro,</span><br></br><span>Davinci Resolve, Ableton Live, Audacity, QLC+ lighting controller.</span></td>
              </tr>
            </tbody>
            </table>
        </div>
      </div>
    </section>
  );
};

export default Skills;
